export default __webpack_public_path__ + "static/media/icons-logout.59264e59.svg";